// ES translations
export const es = {
    // Navigation
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      successStories: 'Casos de Éxito',
      blog: 'Blog',
      contact: 'Contacto'
    },
    // Hero Section
    hero: {
      badge: 'Genealogista Experta Laura Stella - 30 Años de Experiencia',
      title: 'Descubre Tus',
      titleHighlight: 'Raíces Italianas',
      description: 'Investigación genealógica profesional que te conecta con tus orígenes italianos',
      introHeadline: 'Cada historia familiar comienza con una pregunta. Nosotros te ayudamos a encontrar las respuestas.',
      introSupport: 'Investigación basada en fuentes históricas reales, documentos verificables y apoyo humano dedicado.',
      cta: 'Comienza Tu Viaje',
      viewServices: 'Ver Servicios',
      stats: {
        projects: 'Proyectos Completados',
        experience: 'Años de Experiencia',
        countries: 'Países Atendidos'
      },
      certified: 'Experto Certificado',
      certifiedSub: 'Investigación Archivos Italianos'
    },
    // Services Section
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones completas para la investigación genealógica',
      items: [
        {
          title: 'Investigación Genealógica',
          description: 'Investigación profunda de archivos italianos para rastrear la historia de tu familia a través de generaciones.'
        },
        {
          title: 'Recuperación de Documentos',
          description: 'Obtenemos certificados de nacimiento, matrimonio y defunción de archivos municipales y parroquiales italianos.'
        },
        {
          title: 'Asistencia Ciudadanía',
          description: 'Guía experta a través del proceso de solicitud de ciudadanía italiana por descendencia (jure sanguinis).'
        },
        {
          title: 'Traducción de Documentos',
          description: 'Traducción profesional y apostilla de documentos italianos para uso legal.'
        },
        {
          title: 'Tours Ancestrales',
          description: 'Viajes personalizados a los lugares de origen de tu familia en Italia.'
        }
      ]
    },
    // About Section
    about: {
      title: 'Sobre Nosotros',
      subtitle: 'Tu Socio en el Descubrimiento del Patrimonio Italiano',
      description1: 'Con más de 30 años de experiencia en investigación genealógica italiana, Laura Stella ha ayudado a cientos de familias a descubrir sus raíces italianas y obtener la ciudadanía italiana.',
      description2: 'Nuestro equipo de investigadores expertos trabaja directamente con archivos italianos, parroquias y oficinas municipales para encontrar los documentos necesarios para tu investigación familiar.',
      features: [
        'Acceso directo a archivos italianos',
        'Equipo de investigadores nativos',
        'Más de 500 casos de éxito',
        'Soporte completo para ciudadanía'
      ]
    },
    // Success Stories
    stories: {
      title: 'Casos de Éxito',
      subtitle: 'Familias que descubrieron sus raíces',
      items: [
        {
          name: 'Marco R.',
          location: 'Nueva York, EE.UU.',
          quote: '¡La precisión y exactitud de la investigación me asombraron. Encontraron detalles sobre mi familia que ni mis abuelos conocían!'
        },
        {
          name: 'Sarah M.',
          location: 'Sídney, Australia',
          quote: 'Encontraron documentos de mi familia que datan de 1800. Una experiencia increíble.'
        },
        {
          name: 'Carlos G.',
          location: 'Buenos Aires, Argentina',
          quote: 'Profesionalismo y dedicación. Resolvieron un caso complejo que otros habían abandonado.'
        }
      ]
    },
    // Blog
    blog: {
      title: 'Blog de Genealogía',
      subtitle: 'Guías, consejos e historias sobre investigación genealógica italiana',
      readMore: 'Leer Artículo',
      backToSite: 'Volver al Sitio',
      backToBlog: 'Volver al Blog',
      minRead: 'min de lectura',
      categories: {
        citizenship: 'Ciudadanía',
        research: 'Investigación',
        genealogy: 'Genealogía',
        documents: 'Documentos'
      }
    },
    // Contact
    contact: {
      title: 'Contáctanos',
      subtitle: 'Comienza tu viaje hacia las raíces italianas',
      form: {
        name: 'Nombre Completo',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        message: 'Mensaje',
        ancestorOrigin: 'Lugar de origen de tu antepasado (si lo conoces)',
        submit: 'Enviar Solicitud'
      },
      info: {
        title: 'Información de Contacto',
        email: 'italianrootsdiscovery@gmail.com',
        phone: '+39 3318792031',
        address: 'Milán • Turín • Génova • Venecia • Padua • Roma • Nápoles • Palermo'
      }
    },
    // Footer
    footer: {
      description: 'Investigación genealógica profesional que te conecta con tus raíces italianas.',
      quickLinks: 'Enlaces Rápidos',
      contactUs: 'Contáctanos',
      followUs: 'Síguenos',
      rights: 'Todos los derechos reservados.',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies'
    }
  };
